import React, { useState, useEffect } from "react";
import { useCheckPhoneExistsQuery } from "../properties/PropertiesApiSlice";
const PhoneTagInput = ({ value = [], onChange, onDuplicateFound }) => {
    const [input, setInput] = useState("");
    const [checkingPhone, setCheckingPhone] = useState(null);

    // TÍNH NĂNG CHECK SDT TRÙNG - TẠM THỜI COMMENT
    // KHI MỞ LẠI CŨNG MỞ isFetching, checkingPhone, setCheckingPhone
    // START
    // const { data: exists = false, isFetching } = useCheckPhoneExistsQuery(checkingPhone, {
    //     skip: !checkingPhone || checkingPhone.length < 9
    // });

    // // Khi có kết quả kiểm tra
    // useEffect(() => {
    //     if (!checkingPhone || isFetching) return;
    //     if (exists) {
    //         // Gọi callback để Welcome.js hiện modal
    //         onDuplicateFound?.(checkingPhone);
    //     }
    //     // Nếu không trùng → không làm gì, số đã được thêm rồi
    //     setCheckingPhone(null);
    // }, [exists, isFetching, checkingPhone, onDuplicateFound]);
    // END    

    const addPhone = () => {
        let phone = input.trim().replace(/[^\d]/g, "");

        if (!phone) return;

        // Chuẩn hóa +84 → 0
        if (phone.startsWith("84") && phone.length > 10) {
            phone = "0" + phone.slice(2);
        }

        if (phone.length < 9 || phone.length > 11) {
            alert("Số điện thoại không hợp lệ (9–11 số)");
            return;
        }

        if (value.includes(phone)) {
            alert("Số này đã được thêm rồi!");
            setInput("");
            return;
        }

        // Luôn thêm vào danh sách trước
        onChange([...value, phone]);

        // Bắt đầu kiểm tra trùng (chỉ để hiện modal, không xóa)
        // setCheckingPhone(phone);
        setInput("");
    };

    const removePhone = (phoneToRemove) => {
        onChange(value.filter(p => p !== phoneToRemove));
    };

    const handleKeyDown = (e) => {
        if (["Enter", ",", " "].includes(e.key)) {
            e.preventDefault();
            addPhone();
        }
    };

    return (
        <div>
            <label className="form-label fw-semibold">
                Số điện thoại <span className="text-danger">*</span>
                {/* {isFetching && <small className="text-info ms-2">(đang kiểm tra...)</small>} */}
            </label>

            <div className="input-group mb-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Nhập SĐT rồi Enter / phẩy / cách"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={addPhone}
                    // disabled={isFetching}
                >
                    Thêm
                </button>
            </div>

            <div className="d-flex flex-wrap gap-2">
                {value.map((phone) => (
                    <span key={phone} className="badge bg-primary text-white p-2">
                        {phone}
                        <button
                            type="button"
                            className="btn-close btn-close-white ms-2"
                            style={{ fontSize: "0.7rem" }}
                            onClick={() => removePhone(phone)}
                        />
                    </span>
                ))}
            </div>

            {value.length === 0 && <small className="text-white">Chưa có số điện thoại</small>}
        </div>
    );
};

export default PhoneTagInput;